import { HSMSIcon } from '@components/shared';
import { Card } from 'antd';
import Link from 'next/link';

interface DashboardLinkArgs {
  link: string;
  linkText: string;
  iconName: string;
}

export const DashboardLink = ({ link, linkText, iconName }: DashboardLinkArgs) => {
  return (
    <Link href={link}>
      <div>
        <Card className="dashboard-inner-card">
          <HSMSIcon name={iconName} className="dashboard-link-icon" /> {linkText} <div className="inner-link-spacer" />
          <HSMSIcon name="navigate_next" className="dashboard-link-arrow-icon" />
        </Card>
      </div>
    </Link>
  );
};
